import { dispatchDownloadBulkrunTemplate } from "../../redux/actions/content";
import { WizrAzurOrchestratorBulkRun } from "../../utils/wizrAzureConnector";
import WizrButton from "../WizrButton"


const BulkRunDownload=(appDetail:any):JSX.Element=>{
  const file= appDetail?.fileName?.output_file_name
    const fileDownloadAction = async (file:any)=>{
       // await WizrAzurOrchestratorBulkRun.downloadFileOutput(appDetail?.fileName?.app_id, file)
       const file_name = file
       const payload = { "container_id": 2, "path": `outbox/${appDetail?.fileName?.app_id}` }
       dispatchDownloadBulkrunTemplate(payload, file_name)
    }
    
    return(
        <WizrButton type='link' text={file} color={"black"} style={{textDecoration:"underline",whiteSpace: "normal", wordWrap: "break-word" ,height:"auto",textAlign:"left"}} onClick={()=>{fileDownloadAction(file)}}/>
    )
}
export default BulkRunDownload